/**
 * About you options exactly as stored today. The stored values feed saved
 * answers and the admin Demographics stats, so they never change here.
 */
export const OCCUPATION_OPTIONS = [
  { id: "student", label: "Student" },
  { id: "remote_worker", label: "Remote Worker" },
  { id: "freelancer", label: "Freelancer" },
  { id: "business_owner", label: "Business Owner" },
  { id: "hybrid_worker", label: "Hybrid Worker" },
  { id: "founder", label: "Founder" },
  { id: "cafe_lover", label: "Café Lover" },
] as const;

export const AGE_RANGE_OPTIONS = ["18–24", "25–34", "35–44", "45+", "Prefer not to say"] as const;

export const FREQUENCY_OPTIONS = [
  { id: "daily", label: "Daily" },
  { id: "few_times_week", label: "A few times a week" },
  { id: "occasionally", label: "Occasionally" },
] as const;

export const REFERRAL_OPTIONS = [
  { id: "tiktok", label: "TikTok" },
  { id: "instagram", label: "Instagram" },
  { id: "google_search", label: "Google search" },
  { id: "app_store", label: "App Store" },
  { id: "friend", label: "Friend or word of mouth" },
  { id: "other", label: "Other" },
] as const;

export interface AboutYouAnswers {
  occupation: string;
  ageRange: string;
  cafeFrequency: string;
  referralSource: string;
}

/** Only values from today's lists are ever written; anything else is dropped. */
export function sanitizeAboutYou(a: AboutYouAnswers): Partial<Record<"occupation" | "age_range" | "cafe_frequency" | "referral_source", string>> {
  const out: Partial<Record<"occupation" | "age_range" | "cafe_frequency" | "referral_source", string>> = {};
  if (OCCUPATION_OPTIONS.some((o) => o.id === a.occupation)) out.occupation = a.occupation;
  if ((AGE_RANGE_OPTIONS as readonly string[]).includes(a.ageRange)) out.age_range = a.ageRange;
  if (FREQUENCY_OPTIONS.some((o) => o.id === a.cafeFrequency)) out.cafe_frequency = a.cafeFrequency;
  if (REFERRAL_OPTIONS.some((o) => o.id === a.referralSource)) out.referral_source = a.referralSource;
  return out;
}

/** Line above the greyed Continue on About you, or null when all three are in. */
export function aboutYouMissingLine(a: AboutYouAnswers): string | null {
  const missing: string[] = [];
  if (!a.occupation) missing.push("what best describes you");
  if (!a.ageRange) missing.push("your age");
  if (!a.cafeFrequency) missing.push("how often you work from cafés");
  if (missing.length === 0) return null;
  if (missing.length === 1) return `One more to go: ${missing[0]}.`;
  return "Answer the first three questions to continue.";
}
